import { Chrome, Compass, Package } from 'lucide-react';
import { LucideIcon } from 'lucide-react';

// Map of known app names to their Lucide icons
const APP_ICON_MAP: Record<string, LucideIcon> = {
  'Chrome': Chrome,
  'Google Chrome': Chrome,
  'Safari': Compass, // Safari uses Compass icon
  'Safari Technology Preview': Compass,
};

// Known apps that appear in Apple updates
const KNOWN_APP_NAMES = [
  'Safari',
  'Safari Technology Preview',
  'Xcode',
  'Final Cut Pro',
  'Logic Pro',
  'GarageBand',
  'Pages',
  'Numbers',
  'Keynote',
  'Motion',
  'Compressor',
  'iMovie',
  'MainStage',
  'Aperture',
  'TestFlight'
];

export function getAppIcon(appName: string): LucideIcon {
  // Check for exact match
  if (APP_ICON_MAP[appName]) {
    return APP_ICON_MAP[appName];
  }
  
  // Check for partial match (case insensitive)
  const lowerAppName = appName.toLowerCase();
  for (const [key, icon] of Object.entries(APP_ICON_MAP)) {
    if (lowerAppName.includes(key.toLowerCase())) {
      return icon;
    }
  }
  
  // Default fallback
  return Package;
}

export function getAppIconColor(appName: string): string {
  const lowerAppName = appName.toLowerCase();
  
  if (lowerAppName.includes('chrome')) {
    return 'text-[#4285F4]'; // Google Chrome blue
  }
  if (lowerAppName.includes('safari')) {
    return 'text-[#006CFF]'; // Safari blue
  }
  
  return 'text-muted-foreground';
}

export function isAppUpdate(updateName: string): boolean {
  return KNOWN_APP_NAMES.some(appName => 
    updateName.includes(appName)
  );
}

export function extractAppName(updateName: string): string | null {
  const match = KNOWN_APP_NAMES.find(appName => 
    updateName.includes(appName)
  );
  return match || null;
}
